import { render, staticRenderFns } from "./AppraisalLifecycleCost.vue?vue&type=template&id=71772703&"
import script from "./AppraisalLifecycleCost.vue?vue&type=script&lang=ts&"
export * from "./AppraisalLifecycleCost.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports